import styled from "styled-components";

export const StyledFooter = styled.div`
  .bottom {
    width: 1000px;
    font: 12px Microsoft JhengHei, arial;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    margin: 40px auto 0;
  }

  .logos {
    width: 180px;
    height: 45px;
    display: flex;
    margin: 0 auto 20px;
    background: url("https://cdngarenanow-a.akamaihd.net/games/lol/2020/LOLwebsite/img/footer/logos.png")
      no-repeat center 0;
  }

  .cnt {
    flex: 1;
    text-align: left;
  }

  .social-links {
    margin-top: 30px;
    text-align: center;
  }

  .playForFree {
    color: #1398e6;
    width: 180px;
    height: 50px;
    line-height: 52px;
    font-size: 16px;
    font-weight: 600;
    display: inline-block;
    background: url("https://cdngarenanow-a.akamaihd.net/web/image/lol/landing-dominion/WEBSITE/img/footer/playForFree.png")
      no-repeat;
    background-size: contain;
    vertical-align: middle;
  }

  @media screen and (max-width: 750px) {
    .playForFree {
      display: none;
    }
  }
`;
